import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const NAME_VALIDATION = {
  MIN_LENGTH: 3,
  MAX_LENGTH: 40,
};

export const isValidName = (name: string) => name.trim().length >= NAME_VALIDATION.MIN_LENGTH;
